import { DeliverySpeedDetail, UserAddress } from "@swiggy-private/cart-types";
import { getSelectedSLA } from "./Header";

export const checkIsRangeSla = (slaOptions: DeliverySpeedDetail[], selectedType: string): boolean => {
    const selectedOption = slaOptions.find(option => option.type === selectedType);
    return selectedOption?.sla_range_min !== selectedOption?.sla_range_max;
};

export const getBoltSlaData = (
    isBolt: boolean,
    userAddress?: UserAddress,
): { boltSla: number | null; isRangeSla: boolean } => {
    if (!isBolt) return { boltSla: null, isRangeSla: false };

    return {
        boltSla: userAddress?.sla_options
            ? getSelectedSLA(userAddress.sla_options, userAddress.selected_sla_option || "")
            : null,
        isRangeSla:
            !!userAddress?.sla_options &&
            checkIsRangeSla(userAddress?.sla_options, userAddress?.selected_sla_option || ""),
    };
};
